import React, { useMemo } from 'react';
import RendererActions from '../../actions/index';
export var RendererContext = /*#__PURE__*/React.createContext(new RendererActions());
export function RendererActionsContext(_ref) {
  var children = _ref.children,
    context = _ref.context;
  var actions = useMemo(function () {
    return new RendererActions(true);
  }, []);
  return /*#__PURE__*/React.createElement(RendererContext.Provider, {
    value: context || actions
  }, React.Children.only(children));
}
export var RendererActionsContextConsumer = RendererContext.Consumer;